// extracted by mini-css-extract-plugin
export default {"Virtual":"Virtual_Virtual__0ue64","left":"Virtual_left__F6jDo","wrapper":"Virtual_wrapper__NjYSO"};